<template>
  <ModalCard>
    <template #custom>
      <div class="py-5 iframe-container">
        <iframe title="Terms of use" class="iframe-box" :src="termsOfUse" />
      </div>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '/@/modules/core/ui/components/ModalCard.vue';
import { ContactUsInfoMixin } from '@/modules/auth/mixins/ContactUsInfoMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TermsOfUseModal',
  mixins: [ContactUsInfoMixin],
  components: { ModalCard }
};
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 60px);
}
.iframe-box {
  width: 100%;
  height: 100%;
}
</style>
